<template>
  <ToastModal
    ref="modal"
    show-mobile-footer
    modal-id="TermsofUseModal"
    :width="800"
    :title="$t('TermsOfUse.Content.Title')"
  >
    <div class="pt-5 md:pt-12">
      <p class="o-caption md:ota-body-light" v-html="$t('TermsOfUse.Content.Description')" />
    </div>
    <TermsOfUseComponent />
    <template v-slot:footer>
      <ToastModalFooter class="w-full" color="black" variant="outline" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import TermsOfUseComponent from '@/components/TermsOfUseComponent'

export default {
  name: 'TermsofUseModal',
  components: {
    ToastModal,
    TermsOfUseComponent,
    ToastModalFooter
  },
  methods: {
    toggleActivation (isOpen = true) {
      this.$refs.modal.toggleActivation(isOpen)
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    }
  }
}
</script>

<style scoped lang="postcss">
>>> .terms-of-use-component {
  &-subject-title {
    @apply hidden;
  }
}
</style>
